import api from './api';

const supportTicketService = {
  createTicket: async (formData) => {
    const response = await api.post('/tickets/create', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getMyTickets: async () => {
    const response = await api.get('/tickets/mine');
    return response.data;
  },

  getTicket: async (ticketId) => {
    const response = await api.get(`/tickets/${ticketId}`);
    return response.data;
  },

  updateTicketStatus: async (ticketId, payload) => {
    const response = await api.patch(`/tickets/${ticketId}/status`, payload);
    return response.data;
  },

  verifyCloseTicket: async (ticketId) => {
    const response = await api.post(`/tickets/${ticketId}/verify-close`);
    return response.data;
  },

  getNotifications: async (unreadOnly = false) => {
    const response = await api.get('/tickets/notifications', {
      params: unreadOnly ? { unread: 1 } : undefined
    });
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await api.get('/tickets/notifications/count');
    return response.data;
  },

  markNotificationRead: async (notificationId) => {
    const response = await api.patch(`/tickets/notifications/${notificationId}/read`);
    return response.data;
  },

  markAllNotificationsRead: async () => {
    const response = await api.patch('/tickets/notifications/read-all');
    return response.data;
  }
};

export default supportTicketService;
